import { Controller } from "@hotwired/stimulus";
import Highcharts from "highcharts";
import HighchartsMoreFn from "highcharts/highcharts-more";
import HighchartsAccessibilityFn from "highcharts/modules/accessibility";
import HighchartsNoData from "highcharts/modules/no-data-to-display";
HighchartsMoreFn(Highcharts);
HighchartsAccessibilityFn(Highcharts);
HighchartsNoData(Highcharts);
import {
  columnNameConfig,
  sortConfig,
  hideColumn,
  fontBaseLength,
  fontBaseLengthForSp,
  otherKindColumnColor,
  bondColumnColor,
} from "./column_charts/config";

// Connects to data-controller="column-chart"
export default class extends Controller {
  static targets = ["legend", "chart", "yearButtons", "yearLabel"];

  static values = {
    name: String,
    id: String,
    year: Number,
    type: String,
    data: Object,
    width: String,
    height: String,
  };

  connect() {
    this.createCompareChart()
  }

  createCompareChart() {
    this.yearButtonsTarget.querySelectorAll("input")[0].checked = true;
    this.yearChange();
  }

  draw(options) {
    if (options.series.length > 0) {
      this.yearButtonsTarget.classList.remove("hidden");
      this.legendTarget.classList.remove("hidden");
    } else {
      this.chart = Highcharts.setOptions({
        lang: {
          noData: "該当データはありません。",
        },
      });
      this.yearButtonsTarget.classList.add("hidden");
      this.legendTarget.classList.add("hidden");
    }
    // Render chart
    this.chart = Highcharts.chart(this.chartTarget, options);
  }

  async allData() {
    let url = `/json/funds/${this.idValue}/fund_and_category_returns`;
    let value = {};
    // Making our request
    await fetch(url, { method: "GET" })
      .then((Result) => Result.json())
      .then((string) => {
        value = string;
      })
      .catch((errorMsg) => {
        console.log(errorMsg);
      });

    if (value) {
      let options = this.checkDataByYear(value);
      this.draw(options);
    }
  }

  checkDataByYear(value) {
    // if data is empty, year button will hidden
    const yearBtnList = this.yearButtonsTarget.querySelectorAll("input");
    yearBtnList.forEach((btn, idx) => {
      let labelOfInput = this.yearButtonsTarget.querySelectorAll("label")[idx];
      if (Object.keys(value).includes(btn.value)) {
        labelOfInput.classList.add("cursor-pointer");
      } else {
        labelOfInput.classList.add(
          "opacity-40",
          "pointer-events-none"
        );
      }
    });

    // Get Highchart Options
    let data = value[this.yearValue];
    return this.getOptions(data);
  }

  getOptions(data) {
    let optionsByVariant =
      "sp" == this.typeValue ? this.optionsForSp() : this.options();

    // 获取categories
    let dataKeys = [];
    for (let key in data) dataKeys.push(key);
    let categories = this.getCategories(dataKeys);
    let categoriesName = [];
    categories.forEach((col) => {
      let columnName = columnNameConfig[col] || this.nameValue;
      categoriesName.push(columnName);
    });

    optionsByVariant.xAxis.categories = categoriesName;

    // 柱状图平均值datalabel显示  手机版与pc版显示位置统一
    let series = this.getSeriesForSp(categories, data);
    optionsByVariant.series = series;

    return optionsByVariant;
  }

  getCategories(columns) {
    let hideCol = hideColumn;
    let bond = columns.filter(
      (col) => sortConfig.indexOf(col) == -1 && hideCol.indexOf(col) == -1
    );
    let categories = bond.concat(
      sortConfig.filter((col) => columns.indexOf(col) != -1)
    );
    return categories;
  }

  getSeriesForSp(categories, datas) {
    let series = [];
    let columnRangeSeries = {};
    let lineSeries = {};
    if (datas == undefined || datas == null || datas == {}) return series;

    columnRangeSeries.type = "columnrange";
    columnRangeSeries.data = [];

    lineSeries.type = "line";
    lineSeries.data = [];

    categories.forEach((col) => {
      let data = datas[col];
      let color =
        sortConfig.indexOf(col) == -1 ? bondColumnColor : otherKindColumnColor;
      columnRangeSeries.data.push({
        low: this.formatNum(data.min_val),
        high: this.formatNum(data.max_val),
        color: color,
        rangeLength: this.formatNum(data.max_val - data.min_val),
        avg: this.formatNum(data.avg_val),
      });
      lineSeries.data.push(this.formatNum(data.avg_val));
    });

    var columnRangeSeriesArr =
      this.typeValue == "sp"
        ? this.setColumnRangeDatelabelForSp(columnRangeSeries)
        : this.setColumnRangeDatelabel(columnRangeSeries);

    series = series.concat(columnRangeSeriesArr);
    series.push(lineSeries);

    return series;
  }

  formatNum(num) {
    return parseInt(num * 10000) / 100;
  }

  setColumnRangeDatelabel(columnRangeSeries) {
    let maxRange = columnRangeSeries.data
      .map((c) => c.rangeLength)
      .reduce((cur, pro) => {
        return Math.max(cur, pro);
      });

    let baseLength = fontBaseLength;

    let columnRangeSeriesArr = columnRangeSeries.data.map((arr, i) => {
      let data = new Array(columnRangeSeries.data.length).fill(null);
      data[i] = arr;

      let maxToAvg = Math.abs(arr.high * 100 - arr.avg * 100);
      let yHigh = 0;

      if ((maxRange * 100) / Math.abs(maxToAvg) > 40) {
        yHigh = parseInt(baseLength);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 35) {
        yHigh = parseInt((baseLength * 6) / 7);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 30) {
        yHigh = parseInt((baseLength * 5) / 7);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 25) {
        yHigh = parseInt((baseLength * 4) / 7);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 15) {
        yHigh = parseInt(baseLength / 2);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 14) {
        yHigh = parseInt(baseLength / 3);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 13) {
        yHigh = parseInt(baseLength / 4);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 12) {
        yHigh = parseInt(baseLength / 5);
      }

      return {
        type: "columnrange",
        data: data,
        dataLabels: {
          enabled: true,
          yHigh: yHigh,
        },
      };
    });

    return columnRangeSeriesArr;
  }

  setColumnRangeDatelabelForSp(columnRangeSeries) {
    let maxRange = columnRangeSeries.data
      .map((c) => c.rangeLength)
      .reduce((cur, pro) => {
        return Math.max(cur, pro);
      });

    let baseLength = fontBaseLengthForSp;

    let columnRangeSeriesArr = columnRangeSeries.data.map((arr, i) => {
      let data = new Array(columnRangeSeries.data.length).fill(null);
      data[i] = arr;

      let maxToAvg = Math.abs(arr.high * 100 - arr.avg * 100);
      let yHigh = 0;

      if ((maxRange * 100) / Math.abs(maxToAvg) > 90) {
        yHigh = parseInt(baseLength);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 80) {
        yHigh = parseInt((baseLength * 11) / 12);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 70) {
        yHigh = parseInt((baseLength * 10) / 12);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 60) {
        yHigh = parseInt((baseLength * 9) / 12);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 50) {
        yHigh = parseInt((baseLength * 8) / 12);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 45) {
        yHigh = parseInt((baseLength * 7) / 12);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 40) {
        yHigh = parseInt((baseLength * 6) / 12);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 30) {
        yHigh = parseInt((baseLength * 5) / 12);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 25) {
        yHigh = parseInt((baseLength * 4) / 12) - 1;
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 20) {
        yHigh = parseInt((baseLength * 3) / 12);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 14) {
        yHigh = parseInt(baseLength / 3);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 13) {
        yHigh = parseInt(baseLength / 4);
      } else if ((maxRange * 100) / Math.abs(maxToAvg) > 12) {
        yHigh = parseInt(baseLength / 5);
      }

      return {
        type: "columnrange",
        data: data,
        dataLabels: {
          enabled: true,
          yHigh: yHigh,
        },
      };
    });

    return columnRangeSeriesArr;
  }

  optionsForSp() {
    return {
      chart: {
        inverted: false,
        plotBorderColor: "#000",
        plotBorderWidth: 0,
        marginRight: 1,
        height: this.heightValue,
        width: this.widthValue,
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
      title: null,
      xAxis: {
        title: {
          enabled: false,
        },
        labels: {
          enabled: true,
          style: {
            fontFamily:
              "-apple-system,'BlinkMacSystemFont','Hiragino Kaku Gothic ProN','Noto Sans CJK JP','Noto Sans JP','Noto Sans',sans-serif",
            fontSize: "11px",
            color: "#666666",
          },
          formatter: function () {
            var val = "";
            for (var i = 0; i < this.value.length; i++) {
              var str = this.value[i];
              if (str == "ー") str = "|";
              val += str + "<br>";
            }
            return val;
          },
        },
        tickLength: 0,
        lineWidth: 0,
        plotLines: [
          {
            color: "#ed6d34",
            width: 2,
            value: 0.5,
            zIndex: 0,
          },
        ],
      },
      yAxis: {
        title: {
          enabled: false,
        },
        labels: {
          style: {
            fontFamily:
              "-apple-system,'BlinkMacSystemFont','Hiragino Kaku Gothic ProN','Noto Sans CJK JP','Noto Sans JP','Noto Sans',sans-serif",
            fontSize: "11px",
            color: "#666666",
          },
        },
        gridLineDashStyle: "longdash",
        gridLineColor: "#ccc",
        tickColor: "#000",
        tickLength: 0,
        tickWidth: 0.4,
        tickPosition: "inside",
        gridLineWidth: 0.4,
        plotLines: [
          {
            color: "#f20000",
            width: 0.8,
            value: 0,
            zIndex: 2,
          },
        ],
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        columnrange: {
          grouping: false,
          animation: false,
          dataLabels: {
            useHTML: true,
            allowOverlap: true,
            crop: false,
            overflow: "none",
            padding: 0,
            style: {
              fontSize: "8px",
              textOutline: "none",
              fontWeight: "normal",
              fontFamily: "",
            },
            zIndex: 20,
          },
          borderWidth: 0,
          borderColor: "#000",
          allowPointSelect: false,
          enableMouseTracking: false,
          pointWidth: 20,
        },
        series: {
          states: {
            inactive: {
              opacity: 1,
            },
          },
        },
        line: {
          marker: {
            enabled: true,
            symbol: "circle",
            fillColor: "#fff800",
            lineWith: 0,
          },
          animation: false,
          lineWidth: 0,
          allowPointSelect: false,
          enableMouseTracking: false,
          dataLabels: {
            enabled: true,
            allowOverlap: true,
            padding: 0,
            shape: "callout",
            crop: false,
            overflow: "none",
            backgroundColor: "transparent",
            borderWidth: 0,
            borderColor: "#000",
            style: {
              fontSize: "8px",
              textOutline: "none",
              fontWeight: "normal",
              position: "relative",
              fontFamily:
                "-apple-system,'BlinkMacSystemFont','Hiragino Kaku Gothic ProN','Noto Sans CJK JP','Noto Sans JP','Noto Sans',sans-serif",
            },
            useHTML: true,
            formatter: function () {
              var lineLabels =
                '<div class="p-0.25 text-itf-3xs leading-2 bg-slate-300/60 min-w-5.5 text-center">' +
                this.y +
                "</div>";
              return lineLabels;
            },
            y: -5,
            zIndex: 20,
          },
        },
      },
      legend: {
        enabled: false,
      },
      noData: {
        style: {
          fontWeight: "normal",
          fontSize: "14px",
          color: "#303030",
          fontFamily:
            "-apple-system,'BlinkMacSystemFont','Hiragino Kaku Gothic ProN','Noto Sans CJK JP','Noto Sans JP','Noto Sans',sans-serif",
        },
      },
    };
  }

  options() {
    return {
      chart: {
        inverted: false,
        plotBorderColor: "#000",
        plotBorderWidth: 0,
        marginRight: 20,
        height: this.heightValue,
        width: this.widthValue,
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
      title: null,
      xAxis: {
        title: {
          enabled: false,
        },
        labels: {
          enabled: true,
          style: {
            fontFamily:
              "-apple-system,'BlinkMacSystemFont','Hiragino Kaku Gothic ProN','Noto Sans CJK JP','Noto Sans JP','Noto Sans',sans-serif",
            fontSize: "11px",
            color: "#666666",
          },
          formatter: function () {
            let val = "";
            if (["ファンド", "その他"].indexOf(this.value) != -1)
              return this.value;
            let index = 1;
            if (["新興国債券", "新興国株式"].indexOf(this.value) != -1)
              index = 2;
            for (let i = 0; i < this.value.length; i++) {
              val += i == index ? this.value[i] + "<br>" : this.value[i];
            }
            return val;
          },
        },
        tickLength: 0,
        lineWidth: 0,
        plotLines: [
          {
            color: "#ed6d34",
            width: 2,
            value: 0.5,
            zIndex: 0,
          },
        ],
      },
      yAxis: {
        title: {
          enabled: false,
        },
        labels: {
          style: {
            fontFamily:
              "-apple-system,'BlinkMacSystemFont','Hiragino Kaku Gothic ProN','Noto Sans CJK JP','Noto Sans JP','Noto Sans',sans-serif",
            fontSize: "11px",
            color: "#666666",
          },
        },
        gridLineDashStyle: "longdash",
        gridLineColor: "#ccc",
        tickColor: "#000",
        tickLength: 0,
        tickWidth: 0.4,
        tickPosition: "inside",
        gridLineWidth: 0.4,
        plotLines: [
          {
            color: "#f20000",
            width: 0.8,
            value: 0,
            zIndex: 2,
          },
        ],
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        columnrange: {
          grouping: false,
          animation: false,
          dataLabels: {
            enabled: true,
            useHTML: true,
            allowOverlap: true,
            padding: 0,
            crop: false,
            overflow: "none",
            style: {
              fontSize: "12px",
              textOutline: "none",
              fontWeight: "normal",
              fontFamily: "",
            },
            zIndex: 20,
          },
          borderWidth: 0,
          borderColor: "#000",
          allowPointSelect: false,
          enableMouseTracking: false,
          pointWidth: 32,
        },
        series: {
          states: {
            inactive: {
              opacity: 1,
            },
          },
        },
        line: {
          marker: {
            enabled: true,
            symbol: "circle",
            fillColor: "#fff800",
            lineWith: 0,
          },
          animation: false,
          lineWidth: 0,
          allowPointSelect: false,
          enableMouseTracking: false,
          dataLabels: {
            enabled: true,
            allowOverlap: true,
            padding: 0,
            shape: "callout",
            crop: false,
            overflow: "none",
            backgroundColor: "transparent",
            borderWidth: 0,
            borderColor: "#000",
            style: {
              fontSize: "12px",
              textOutline: "none",
              fontWeight: "normal",
              fontFamily:
                "-apple-system,'BlinkMacSystemFont','Hiragino Kaku Gothic ProN','Noto Sans CJK JP','Noto Sans JP','Noto Sans',sans-serif",
            },
            useHTML: true,
            formatter: function () {
              var lineLabels =
                '<div class="py-0.25 px-0.75 text-xs leading-3 bg-slate-300/60 text-center">' +
                this.y +
                "</div>";
              return lineLabels;
            },
            y: -5,
            zIndex: 20,
          },
        },
      },
      legend: {
        enabled: false,
      },
      noData: {
        style: {
          fontWeight: "normal",
          fontSize: "14px",
          color: "#303030",
          fontFamily:
            "-apple-system,'BlinkMacSystemFont','Hiragino Kaku Gothic ProN','Noto Sans CJK JP','Noto Sans JP','Noto Sans',sans-serif",
        },
      },
    };
  }

  yearChange(event) {
    const inputs = this.yearButtonsTarget.querySelectorAll("input");
    inputs.forEach((input) => {
      if (input.checked == true) {
        this.yearValue = parseInt(input.value);
      }
    });
    const selectedLabelClasses = ["py-1", "rounded", "bg-MK-link", "text-white", '!font-bold', 'hover:!text-white', 'hover:!no-underline']
    const getPrevLabel = (element) => {
      let prev = element.previousElementSibling;
      if (prev?.tagName === 'INPUT') {
        prev = prev.previousElementSibling;
      }
      return prev;
    }
    const getNextLabel = (element) => {
      let next = element.nextElementSibling;
      if (next?.tagName === 'INPUT') {
        next = next.nextElementSibling;
      }
      return next;
    }
    this.yearLabelTargets.forEach(label => {
      label.classList.add('first:border-l', 'border-r');
      label.classList.remove(...selectedLabelClasses);
    });
    if (event !== undefined) {
      const selectedLabel = event.target.previousElementSibling;
      selectedLabel.classList.remove('first:border-l', 'border-r');
      selectedLabel.classList.add(...selectedLabelClasses);
      const prevLabel = getPrevLabel(selectedLabel);
      const nextLabel = getNextLabel(selectedLabel);
      if (prevLabel) {
        prevLabel.classList.remove('border-r');
      }
      if (nextLabel) {
        nextLabel.classList.remove('first:border-l');
      }
    } else {
      this.yearLabelTargets[0].classList.add(...selectedLabelClasses)
    }
    this.allData();
  }
}
